import type { PlayerData } from '../../components/PlayersStats/PlayersStats.types';

const sortShotPlayersData = (player1: PlayerData, player2: PlayerData) =>
  (player2.shotsOffTarget || 0) - (player1.shotsOffTarget || 0) ||
  (player2.shotsOnTarget || 0) - (player1.shotsOnTarget || 0);

export default sortShotPlayersData;
